import * as ArrayUtils from "../../../../../utils/ArrayUtil";
import {GenericChecker} from "../../subjective/GenericChecker";

export function getReviewOfSystemNormalText(fieldIsNormal) {
    return isFieldNA(fieldIsNormal) ? "N/A" : fieldIsNormal ? "Normal" : "";
}

function isFieldNA(fieldIsNormal) {
    return fieldIsNormal === null || fieldIsNormal === undefined;
}
export class AssessmentReviewOfSystemChecker extends GenericChecker {
    static isDataEntered(entity) {
        if (entity == null) {
            return false;
        }

        return !(ArrayUtils.isEmpty(entity.cardiovascularCirculatory) && isFieldNA(entity.cardiovascularCirculatoryNormal)
            && ArrayUtils.isEmpty(entity.respiratory) && isFieldNA(entity.respiratoryNormal)
            && ArrayUtils.isEmpty(entity.headNeckEyes) && isFieldNA(entity.headNeckEyesNormal)
            && ArrayUtils.isEmpty(entity.ent) && isFieldNA(entity.entNormal)
            && ArrayUtils.isEmpty(entity.skinHairNails) && isFieldNA(entity.skinHairNailsNormal)
            && ArrayUtils.isEmpty(entity.lymphaticImmune) && isFieldNA(entity.lymphaticImmuneNormal)
            && ArrayUtils.isEmpty(entity.endocrine) && isFieldNA(entity.endocrineNormal)
            && ArrayUtils.isEmpty(entity.gastrointestinal) && isFieldNA(entity.gastrointestinalNormal)
            && ArrayUtils.isEmpty(entity.genitourinary) && isFieldNA(entity.genitourinaryNormal)
            && ArrayUtils.isEmpty(entity.musculoskeletal) && isFieldNA(entity.musculoskeletalNormal)
            && ArrayUtils.isEmpty(entity.neurological) && isFieldNA(entity.neurologicalNormal));
    }
}